__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/2bdd273c8e8ab1b43643f5a19727402805c6ff25/_next/";